import { render, staticRenderFns } from "./data-modal.vue?vue&type=template&id=2daa1cd0&"
import script from "./data-modal.vue?vue&type=script&lang=ts&"
export * from "./data-modal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports